module.exports = __webpack_public_path__ + "static/media/20170806_50day_2412AT.cba4686e.jpg";